import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Params} from '@angular/router';

@Component({
  selector: 'app-custom-button',
  templateUrl: './custom-button.component.html',
  host: {class: 'inline-flex'},
  standalone: false
})
export class CustomButtonComponent {

  @Input() label?: string;
  @Input() icon?: string;
  @Input() transparent = false;
  @Input() onLight = false;
  @Input() link?: string;
  @Input() queryParams?: Params;
  @Input() size: 'sm' | 'md' = 'md';
  @Output() pressed = new EventEmitter<Event>();

  get variantClasses(): string {
    const size = this.size === 'sm'
      ? 'px-[0.9rem] py-[0.45rem] text-sm'
      : 'px-[1.2rem] py-[0.85rem]';

    if (this.transparent && this.onLight) {
      return [
        size,
        'border-[rgba(12,74,110,0.35)] bg-transparent text-[#0c4a6e] shadow-none',
        'hover:border-[#0c4a6e] hover:bg-[rgba(12,74,110,0.06)]'
      ].join(' ');
    }

    if (this.transparent) {
      return [
        size,
        'border-[rgba(255,255,255,0.38)] bg-[rgba(255,255,255,0.04)] text-white shadow-none',
        'hover:border-[rgba(255,255,255,0.6)] hover:bg-[rgba(255,255,255,0.1)]'
      ].join(' ');
    }

    const shadow = this.size === 'sm'
      ? 'shadow-[0_8px_18px_rgba(255,121,0,0.28)]'
      : 'shadow-[0_12px_26px_rgba(255,121,0,0.32)]';

    return [
      size,
      'border-transparent text-white',
      'bg-[linear-gradient(180deg,#ff9a3c_0%,#ff7900_100%)]',
      shadow,
      'hover:bg-[linear-gradient(180deg,#ffab5c_0%,#ff8618_100%)]'
    ].join(' ');
  }
}
